function Delete() {
	return (
		<svg>
			<g>
				<line x1="30%" y1="30%" x2="70%" y2="70%"/>
				<line x1="70%" y1="30%" x2="30%" y2="70%"/>
			</g>
		</svg>
	);
}

export default Delete;
